import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=26293048&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=js"
export * from "./Branch.vue?vue&type=script&lang=js"
import style0 from "./Branch.vue?vue&type=style&index=0&id=26293048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26293048",
  null
  
)

export default component.exports